import { gql } from '@apollo/client';
import { BUDGET_CATEGORY_BASIC } from '../../queries/budget/budgetCategories';

// Crear nueva categoría presupuestaria (solo ADMIN)
export const CREATE_BUDGET_CATEGORY = gql`
  mutation CreateBudgetCategory($input: CreateBudgetCategoryInput!) {
    createBudgetCategory(input: $input) {
      ...BudgetCategoryBasic
    }
  }
  ${BUDGET_CATEGORY_BASIC}
`;

// Actualizar categoría presupuestaria (solo ADMIN)
export const UPDATE_BUDGET_CATEGORY = gql`
  mutation UpdateBudgetCategory($id: ID!, $input: UpdateBudgetCategoryInput!) {
    updateBudgetCategory(id: $id, input: $input) {
      ...BudgetCategoryBasic
    }
  }
  ${BUDGET_CATEGORY_BASIC}
`;

// Eliminar categoría presupuestaria (solo ADMIN)
export const DELETE_BUDGET_CATEGORY = gql`
  mutation DeleteBudgetCategory($id: ID!) {
    deleteBudgetCategory(id: $id) {
      ...BudgetCategoryBasic
    }
  }
  ${BUDGET_CATEGORY_BASIC}
`;

